import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { DateInput } from 'src/components/enterprise/components/DateInput/DateInput';
import { getMonthAvailableFromDateLabel } from 'src/components/oneCorp/features/MealCredit/common/formFields/DateInput/MonthAvailableFromDateInput/MonthAvailableFromDateInput.utils';

export interface MonthAvailableFromDateInputProps {
  disabled?: boolean;
  id: string;
  name: string;
}

export const MonthAvailableFromDateInput = ({
  disabled = false,
  id,
  name,
}: MonthAvailableFromDateInputProps): JSX.Element => {
  const { errors, control, watch, setValue } = useFormContext();
  const { date, monthAvailableOn } = watch(['date', 'monthAvailableOn']);
  const label = getMonthAvailableFromDateLabel(monthAvailableOn);

  useEffect(() => {
    if (date) {
      setValue(name, date, { shouldValidate: true });
    }
  }, [date, setValue, name]);

  return (
    <DateInput
      id={id}
      name={name}
      label={label}
      disabled={disabled}
      control={control}
      error={errors[name]}
    />
  );
};
